import React, { useEffect } from "react";

import { Button, Col, Container, Form, Modal, Row } from "react-bootstrap";
import { Controller, useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import * as yup from "yup";

import { ErrorMessage } from "@hookform/error-message";
import { errorMessage } from "utils/utilities";

export const AddHeaderModal = ({ modalInfo, setModalInfo }) => {
    //
    // States
    //

    const schema = yup.object().shape({
        header: yup.string().required("This field is required"),
    });

    const {
        control,
        formState: { errors },
        handleSubmit,
        reset,
    } = useForm({
        resolver: yupResolver(schema),
    });

    //
    // Functions
    //

    const closeModal = () => {
        setModalInfo({ open: false });
    };

    const saveModal = (data) => {
        setModalInfo({
            open: false,
            header: data.header,
            id: modalInfo.id,
            parent_id: modalInfo?.parent_id || "",
        });
    };

    useEffect(() => {
        reset({
            header: modalInfo.header,
        });
    }, [reset, modalInfo]);

    return (
        <Modal
            show={modalInfo.open}
            onHide={() => setModalInfo({ open: false, action: "add" })}
            size="lg"
            centered
        >
            <Modal.Header closeButton>Add header</Modal.Header>
            <Modal.Body className="m-1">
                <Container fluid className="p-0">
                    <Row>
                        <Col md={12}>
                            <Form.Group className="mb-3">
                                <Form.Label htmlFor="description">
                                    Header name
                                </Form.Label>
                                <Controller
                                    control={control}
                                    defaultValue=""
                                    name="header"
                                    render={({
                                        field: { value, onChange, onBlur },
                                    }) => (
                                        <Form.Control
                                            onChange={onChange}
                                            value={value}
                                            type="text"
                                            className={
                                                errors.header && "is-invalid"
                                            }
                                        />
                                    )}
                                />
                                <ErrorMessage
                                    errors={errors}
                                    name="header"
                                    render={({ message }) =>
                                        errorMessage(message)
                                    }
                                />
                            </Form.Group>
                        </Col>
                    </Row>
                </Container>
            </Modal.Body>
            <Modal.Footer>
                <Row>
                    <Col md={12} className="text-center">
                        <Button
                            variant="primary"
                            type="submit"
                            onClick={handleSubmit(saveModal)}
                        >
                            Submit
                        </Button>
                        <Button variant="link" onClick={() => closeModal()}>
                            Cancel
                        </Button>
                    </Col>
                </Row>
            </Modal.Footer>
        </Modal>
    );
};
